import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { endPoints } from "../../../config";
import { axiosInstnace, getAdminData } from "../../../util/util";

const Modal = ({ isShowing, hide, rates, updateRate }) => {
  const [count, handleCount] = useState(1);
  const [states, handlestates] = useState([]);
  const [firstorder, handlefirstorder] = useState(
    rates && rates.firstorder ? rates.firstorder : "10"
  );
  const [repeatordersamemonth, handlerepeatordersamemonth] = useState(
    rates && rates.repeatordersamemonth ? rates.repeatordersamemonth : "10"
  );
  const [repeatordersubsmonth, handlerepeatordersubsmonth] = useState(
    rates && rates.repeatordersubsmonth ? rates.repeatordersubsmonth : "10"
  );
  const [lowvolume, handlelowvolume] = useState(
    rates && rates.lowvolume ? rates.lowvolume : "3"
  );
  const [highvolume, handlehighvolume] = useState(
    rates && rates.highvolume ? rates.highvolume : "7"
  );
  const [minOrder, handleminOrder] = useState(
    rates && rates.minOrder ? rates.minOrder : "2"
  );
  const [maxOrder, handlemaxOrder] = useState(
    rates && rates.maxOrder ? rates.maxOrder : "5"
  );
  const [minOrderValue, handleminOrderValue] = useState(
    rates && rates.minOrderValue ? rates.minOrderValue : "2"
  );
  const [maxOrderValue, handlemaxOrderValue] = useState(
    rates && rates.maxOrderValue ? rates.maxOrderValue : "3"
  );
  
  const [baseState, handlebaseState] = useState(
    rates && rates.baseState ? rates.baseState : "Maharastra"
  );
  const [baseAddress, handlebaseAddress] = useState(
    rates && rates.baseAddress ? rates.baseAddress : ""
  );
  const [igst, handleigst] = useState(rates && rates.igst ? rates.igst : "18");
  const [cgst, handlecgst] = useState(rates && rates.cgst ? rates.cgst : "9");
  const [sgst, handlesgst] = useState(rates && rates.sgst ? rates.sgst : "9");
  const [EnforceminValue, handleEnforceminValue] = useState(
    rates && rates.EnforceminValue && rates.EnforceminValue == "true"
      ? true
      : rates && rates.EnforceminValue && rates.EnforceminValue == "false"
      ? false
      : true
  );
  const [incentiveCalculationTimeperiodEnabled, handleIncentiveCalculationTimeperiodEnabled] = useState(
    rates && rates.incentiveCalculationTimeperiodEnabled && rates.incentiveCalculationTimeperiodEnabled == "true"
      ? true
      : rates && rates.incentiveCalculationTimeperiodEnabled && rates.incentiveCalculationTimeperiodEnabled == "false"
      ? false
      : true
  );
  const [incentiveCalculationMaxTimeperiod, handleIncentiveCalculationMaxTimeperiod] = useState(
    rates && rates.incentiveCalculationMaxTimeperiod ? rates.incentiveCalculationMaxTimeperiod : ""
  );
  const [user, handleuser] = useState("");
  useEffect(() => {
    handlefirstorder(rates && rates.firstorder ? rates.firstorder : "10");
    handlehighvolume(rates && rates.highvolume ? rates.highvolume : "7");
    handlelowvolume(rates && rates.lowvolume ? rates.lowvolume : "3");
    handleminOrderValue(
      rates && rates.minOrderValue ? rates.minOrderValue : "2"
    );
    handlemaxOrderValue(
      rates && rates.maxOrderValue ? rates.maxOrderValue : "5"
    );
    handleminOrder(rates && rates.minOrder ? rates.minOrder : "2");
    handlemaxOrder(rates && rates.maxOrder ? rates.maxOrder : "5");
    handlerepeatordersamemonth(
      rates && rates.repeatordersamemonth ? rates.repeatordersamemonth : "10"
    );
    handlerepeatordersubsmonth(
      rates && rates.repeatordersubsmonth ? rates.repeatordersubsmonth : "10"
    );
    handlesgst(rates && rates.sgst ? rates.sgst : "9");
    handleigst(rates && rates.igst ? rates.igst : "18");
    handlecgst(rates && rates.cgst ? rates.cgst : "9");
    handlebaseState(rates && rates.baseState ? rates.baseState : "Maharastra");
    handlebaseAddress(rates && rates.baseAddress ? rates.baseAddress :"")
    handleuser(getAdminData());
    handleEnforceminValue(
      rates && rates.EnforceminValue && rates.EnforceminValue == "true"
        ? true
        : rates && rates.EnforceminValue && rates.EnforceminValue == "false"
        ? false
        : true
    );
    handleIncentiveCalculationMaxTimeperiod(
      rates && rates.incentiveCalculationMaxTimeperiod ? rates.incentiveCalculationMaxTimeperiod : ""
    )
    handleIncentiveCalculationTimeperiodEnabled(
      rates && rates.incentiveCalculationTimeperiodEnabled && rates.incentiveCalculationTimeperiodEnabled == "true"
        ? true
        : rates && rates.incentiveCalculationTimeperiodEnabled && rates.incentiveCalculationTimeperiodEnabled == "false"
        ? false
        : true
    )
    getstates();
  }, [rates]);

  const closePopup = () => {
    hide();
    handleCount(1);
  };

  const getstates = async () => {
    let states = await axiosInstnace.get(endPoints.getStateList);
    handlestates(states.data.data.data);
  };
  const updateRates = async (e) => {
    e.preventDefault();
    
    if (
      !firstorder ||
      !repeatordersubsmonth ||
      !repeatordersamemonth ||
      !minOrder ||
      !minOrderValue ||
      !maxOrderValue ||
      !maxOrder ||
      !lowvolume ||
      !highvolume ||
      !igst ||
      !cgst ||
      !sgst ||
      !baseState||
      !baseAddress
    ) {
      toast.error("All the fields are mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "1",
      });
      return;
    }
    const params = {
      firstorder,
      repeatordersamemonth,
      repeatordersubsmonth,
      lowvolume,
      highvolume,
      minOrder,
      maxOrder,
      minOrderValue,
      maxOrderValue,
      EnforceminValue,
      incentiveCalculationTimeperiodEnabled,
      incentiveCalculationMaxTimeperiod,
      igst,
      cgst,
      sgst,
      baseState,
      baseAddress,
      email: user.email,
    };
    if (rates && rates._id) {
      params._id = rates._id;
    }
    let result = await axiosInstnace.post(endPoints.putdsaconfig, params);
    window.location.reload(true);
  };

  return isShowing ? (
    <div className="modal-overlay">
      <div
        className="modal-wrapper thankyou-popup"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div
          className="modal approval"
          style={{ height: "90vh", overflowY: "auto" }}
        >
          <div className="modal-head-cross rate-modal">
            <button
              type="button"
              className="modal-close-button"
              onClick={closePopup}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="approval-content modal-body">
              <div class="popup-container reqst-rejection">
                <h2>Edit Trade Partner Conf</h2>
                <table className="tableView">
                  <tr>
                    <td>
                      <label htmlFor="email">First Order (%)</label>
                    </td>
                    <td>
                      <input
                        name="stationName"
                        type="text"
                        className="form-control"
                        value={firstorder}
                        class="width200 inputBox"
                        onChange={(e) => {
                          
                          handlefirstorder(e.target.value);
                        }}
                      />{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {" "}
                      <placeholderText>
                        {" "}
                        Repeat order in same calendar month  (%)
                      </placeholderText>
                    </td>
                    <td>
                      <input
                        name="trafficUpdate"
                        type="text"
                        className="form-control"
                        value={repeatordersamemonth}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlerepeatordersamemonth(e.target.value);
                        }}
                      />{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {" "}
                      <placeholderText>
                        {" "}
                        Repeat order in subsequent months  (%)
                      </placeholderText>
                    </td>
                    <td>
                      <input
                        name="weatherUpdate"
                        type="text"
                        className="form-control"
                        value={repeatordersubsmonth}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlerepeatordersubsmonth(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Low volume (%) </placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={lowvolume}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlelowvolume(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>High volume (%)</placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={highvolume}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlehighvolume(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Minimum order </placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={minOrder}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleminOrder(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Maximum order </placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={maxOrder}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlemaxOrder(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Minimum order value</placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={minOrderValue}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleminOrderValue(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Maximum order value</placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={maxOrderValue}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlemaxOrderValue(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Base State for GST</placeholderText>
                    </td>
                    <td>
                    <select
                        value={baseState}
                        class="typeDropdown drop-down-icon width200"
                        onChange={(e) => {
                          handlebaseState(e.target.value);
                        }}
                      >
                        {states.map((e)=>{
                          return   <option value={e}>{e}</option> 
                        })}
                      </select>

                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>Post Address</placeholderText>
                    </td>
                    <td>
                    <textarea
                        value={baseAddress}
                        class="width200"
                        onChange={(e) => {
                          handlebaseAddress(e.target.value);
                        }}
                      >
                      </textarea>

                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>IGST (%)</placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={igst}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleigst(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>CGST (%)</placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={cgst}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlecgst(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <placeholderText>SGST (%)</placeholderText>
                    </td>
                    <td>
                      <input
                        name="stockUpdate"
                        type="number"
                        className="form-control"
                        value={sgst}
                        class="width200 inputBox"
                        onChange={(e) => {
                          handlesgst(e.target.value);
                        }}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <placeholderText>Enforce minimum value</placeholderText>
                    </td>
                    <td>
                      <select
                        value={EnforceminValue}
                        class="typeDropdown drop-down-icon width200"
                        onChange={(e) => {
                          handleEnforceminValue(e.target.value);
                        }}
                      >
                        <option value={true}>true</option>
                        <option value={false}>false</option>
                      </select>
                    </td>
                  </tr>
                  
                  <tr>
                    <td>
                      <placeholderText>Enable/Disable Incentive Calculation Timeperiod</placeholderText>
                    </td>
                    <td>
                      <select
                        value={incentiveCalculationTimeperiodEnabled}
                        class="typeDropdown drop-down-icon width200"
                        onChange={(e) => {
                          handleIncentiveCalculationTimeperiodEnabled(e.target.value);
                        }}
                      >
                        <option value={true}>true</option>
                        <option value={false}>false</option>
                      </select>
                    </td>
                  </tr>

                  { (incentiveCalculationTimeperiodEnabled == 'true' || incentiveCalculationTimeperiodEnabled == true) && (
                    <tr>
                      <td>
                        <placeholderText>Incentive Calculation Maximum Timeperiod (months)</placeholderText>
                      </td>
                      <td>
                      <input
                          name="stockUpdate"
                          type="number"
                          className="form-control"
                          value={incentiveCalculationMaxTimeperiod}
                          class="width200 inputBox"
                          onChange={(e) => {
                            handleIncentiveCalculationMaxTimeperiod(e.target.value);
                          }}
                        />
                      </td>
                    </tr>
                  ) }
                  
                </table>
                <div className="popupCampaign-container">
                  <div className="create-camp nonfct-submit">
                    <button onClick={updateRates}>SAVE CHANGES</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="modal-footer cost_button">
         <button className="cncl">Cancel</button>
         <button className="procd">Ok</button>
        </div> */}
      </div>
    </div>
  ) : null;
};

export default Modal;



// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/editdsaconf.jsx